import { render, staticRenderFns } from "./VMXHeader.vue?vue&type=template&id=6dcfcc58&scoped=true"
import script from "./VMXHeader.vue?vue&type=script&lang=js"
export * from "./VMXHeader.vue?vue&type=script&lang=js"
import style0 from "./VMXHeader.vue?vue&type=style&index=0&id=6dcfcc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfcc58",
  null
  
)

export default component.exports